import { useEffect, useMemo, useState } from 'react';
import { SavedSearch } from '../../../../../../components/ProfileArea/types';
import { loadSavedSearches } from './rightAsideSidebar.utils';

export function useSidebarFavorites(isAuthenticated: boolean, isOpen: boolean) {
  const [favorites, setFavorites] = useState<SavedSearch[]>([]);
  const [favoritesLoading, setFavoritesLoading] = useState(false);
  const [activeSavedColumnsId, setActiveSavedColumnsId] = useState<string | null>(null);

  const savedColumns = useMemo(() => favorites.filter(f => f.type === 'columns'), [favorites]);

  useEffect(() => {
    if (!isAuthenticated) {
      setFavorites([]);
      return;
    }
    setFavoritesLoading(true);
    loadSavedSearches()
      .then(setFavorites)
      .finally(() => setFavoritesLoading(false));
  }, [isAuthenticated, isOpen]);

  useEffect(() => {
    if (!activeSavedColumnsId && savedColumns.length > 0) {
      setActiveSavedColumnsId(savedColumns[0].id);
    }
  }, [savedColumns, activeSavedColumnsId]);

  return {
    favorites,
    favoritesLoading,
    savedColumns,
    activeSavedColumnsId,
    setActiveSavedColumnsId,
  };
}
